/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPaymentInvoice } from './ControlPaymentInvoice';
import {
    ControlPaymentInvoiceFromJSON,
    ControlPaymentInvoiceFromJSONTyped,
    ControlPaymentInvoiceToJSON,
} from './ControlPaymentInvoice';

/**
 * 
 * @export
 * @interface ControlPaymentHistoryResponse
 */
export interface ControlPaymentHistoryResponse {
    /**
     * 
     * @type {Array<ControlPaymentInvoice>}
     * @memberof ControlPaymentHistoryResponse
     */
    invoices: Array<ControlPaymentInvoice>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ControlPaymentHistoryResponse
     */
    refunds: Array<any>;
}

/**
 * Check if a given object implements the ControlPaymentHistoryResponse interface.
 */
export function instanceOfControlPaymentHistoryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoices" in value;
    isInstance = isInstance && "refunds" in value;

    return isInstance;
}

export function ControlPaymentHistoryResponseFromJSON(json: any): ControlPaymentHistoryResponse {
    return ControlPaymentHistoryResponseFromJSONTyped(json, false);
}

export function ControlPaymentHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaymentHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoices': ((json['invoices'] as Array<any>).map(ControlPaymentInvoiceFromJSON)),
        'refunds': json['refunds'],
    };
}

export function ControlPaymentHistoryResponseToJSON(value?: ControlPaymentHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoices': ((value.invoices as Array<any>).map(ControlPaymentInvoiceToJSON)),
        'refunds': value.refunds,
    };
}

